import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import isUserLoggedIn from '@app/helpers/isUserLoggedIn'
import { withStyles } from '@app/components/styles'
import {
  saveConditionDataOperand,
  saveConditionDataValue,
  saveConditionStateDescription,
} from '@app/actions/scenes/currentSceneCreating'
import * as syncNotifications from '@app/actions/notifications/notificationsChannel'
import { isIOS } from 'react-device-detect'
import SelectMultichannelSubDeviceValue
  from '@app/components/MyAutomation/Tabs/ScenesScreens/CreateCondition/MultichannelConditions/MultichannelBinarySwitch/SelectMultichannelSubDeviceValue/SelectMultichannelSubDeviceValue'
import SelectMultichannelSubDeviceValueIOS
  from '@app/components/MyAutomation/Tabs/iOS/CreateCondition/MultichannelConditions/MultichannelBinarySwitch/SelectMultichannelSubDeviceValue/SelectMultichannelSubDeviceValue'
import {
  withAccessDenied, withNotifications, withProgressAndErrorMessage, withRouter,
} from '@app/hocs'

const isWebView = navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv')
let enhance = isIOS && isWebView ? withStyles(SelectMultichannelSubDeviceValueIOS) : withStyles(SelectMultichannelSubDeviceValue)

const mapStateToProps = (state) => {
  const { isMobile } = state.mobileDetector
  const { isChangeSubDeviceStateMode } = state.scenes.currentSceneCreating
  return {
    isMobile,
    isChangeSubDeviceStateMode,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
    userLoggedIn: (isUserLoggedIn(state.users.currentUser.user.preferredName)),
    inProgress: state.apiRequest.inProgress,
    errorMessage: state.apiRequest.errorMessage,
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  notifications: syncNotifications.sync,
  saveConditionStateDescription,
  saveConditionDataValue,
  saveConditionDataOperand,
}, dispatch)

enhance = withProgressAndErrorMessage(enhance)
enhance = withAccessDenied(enhance)
enhance = withNotifications(enhance)
enhance = connect(mapStateToProps, mapDispatchToProps)(enhance)

const SelectMultichannelSubDeviceValueEnhanced = enhance

export default withRouter(SelectMultichannelSubDeviceValueEnhanced)
